import ms from "ms";
import { makeHook } from "../../utils/makeSingleArgHook";
import getTaskTemplate from "../requests/getTaskTemplate";
import { taskTemplateUrl } from "../requests/urls";
export function taskTemplateKeyMaker(templateId) {
    return [taskTemplateUrl(templateId)];
}
const useGetTaskTemplate = makeHook(async (templateId, auth) => getTaskTemplate(auth, templateId), (templateId) => taskTemplateKeyMaker(templateId), { staleTime: ms("5minutes") });
export default useGetTaskTemplate;
//# sourceMappingURL=useGetTaskTemplate.js.map